import ProductDetailsPage from './modules/product-details/ProductDetailsPage.svelte';

const app = new ProductDetailsPage({
	target: document.getElementById("product-details-page"),
	props: {
		pageConfig: window['pageConfig']
	}
});

export default app;